module.exports = __webpack_public_path__ + "img/mandiri.4ee3f0f9.svg";